export enum TransactionStep {
  MINING = "Mining",
  INDEXING = "Indexing",
  DONE = "Done",
  FAIL = "Failed",
  CANCELLED = "Cancelled",
}
